import useUrlState from '@ahooksjs/use-url-state'
import { Spin } from 'antd'
import React from 'react'
import InfiniteScroll from 'react-infinite-scroll-component'
import { useLocation } from 'react-router'

import { useGetNotifcationsQuery, useNotificationCountChangedSubscription } from '@/generated/graphql'
import { useNotificationUnreadQuery } from '@/modules/notification/use-notification.hook'

import { Notification, OnClickParam } from './notification.component'
import s from './notification.module.less'

export const NotificationList = () => {
  const location = useLocation()
  const setState = useUrlState<OnClickParam>({} as any, { navigateMode: 'replace' })[1]

  const last = 20

  const { data, loading, error, refetch, fetchMore } = useGetNotifcationsQuery({
    fetchPolicy: 'network-only',
    nextFetchPolicy: 'cache-first',
    notifyOnNetworkStatusChange: true,
    variables: {
      pagination: {
        last,
      },
    },
  })

  const { unreadCount, readNotification } = useNotificationUnreadQuery()

  React.useEffect(() => {
    // 没有 location.search = 通知首页
    if (!location.search) {
      refetch()
    }
  }, [location.search])

  React.useEffect(() => {
    if (unreadCount > 0) {
      readNotification()
    }
  }, [unreadCount])

  useNotificationCountChangedSubscription({
    onSubscriptionData() {
      refetch()
    },
  })

  const edges = data?.viewer.notifications?.edges || []
  const pageInfo = data?.viewer.notifications?.pageInfo || {
    startCursor: null,
    endCursor: null,
    hasPreviousPage: false,
    hasNextPage: false,
  }

  const notifications = edges
    .map(({ node }) => node)
    .filter((n) => !!n.message)
    .slice()
    .reverse()

  if (error) {
    return null
  }

  const loadingComponent = loading && (
    <div className={s.loading}>
      <Spin delay={300} />
    </div>
  )

  return (
    <div className={s.notificationsList} id='notificationListDiv'>
      <InfiniteScroll
        dataLength={notifications.length}
        loader={loadingComponent}
        className={s.notificationsContainer}
        hasMore={pageInfo.hasPreviousPage}
        scrollableTarget='notificationListDiv'
        next={() =>
          fetchMore({
            variables: {
              pagination: {
                last,
                before: pageInfo.startCursor,
              },
            },
          })
        }
      >
        {notifications.map((n) => (
          <Notification key={n.notificationId} notification={n} onClick={setState} />
        ))}
      </InfiniteScroll>
    </div>
  )
}
